import { useCallback } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { PANEL_I18N } from "../i18n/panel";

// t("key", { n: 5 }) → localized string with {n} placeholders replaced; falls back to English.
export function usePanelT() {
    const { language } = useLanguage();
    const lang = PANEL_I18N.__langs.includes(language) ? language : "en";
    const t = useCallback((key, vars) => {
        const entry = PANEL_I18N[key];
        let s = entry ? (entry[lang] ?? entry.en ?? key) : key;
        if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(String(v)); });
        return s;
    }, [lang]);
    return { t, lang, language };
}
